export default __webpack_public_path__ + "static/taxes-a471bc38174ef2233a12250db314ee4e.png";